import Swiper from 'swiper';
import Navigation from '../../node_modules/swiper/modules/navigation.mjs';
import Pagination from '../../node_modules/swiper/modules/pagination.mjs';
import { uniq } from 'lodash';

const getCustomPagination = (container) => ({
  type: 'custom',
  el: container.querySelector('.swiper-pagination'),
  clickable: true,
  renderCustom(currentswiper, current, total) {
    const visiblePagerItems = uniq([
      1,
      current - 1,
      current,
      current + 1,
      total,
    ])
      .filter((x) => x > 0)
      .filter((x) => x <= total)
      .sort(Number)
      .reverse();
    let lastHidden = false;
    if (currentswiper.el.dataset.dots) {
      return new Array(total < 0 ? 0 : total)
        .fill(null)
        .map((_, index) => {
          let className = 'swiper-pagination-bullet swiper-pagination-dot';
          if (current === index + 1) {
            className +=
              ' swiper-pagination-bullet-active swiper-pagination-dot-active';
          }
          /* eslint-disable indent */
          return `<span class="${className}" tabindex="0"></span>`;
          /* eslint-enable indent */
        })
        .join('\n');
    }
    return new Array(total < 0 ? 0 : total)
      .fill(null)
      .map((_, index) => {
        let className = 'swiper-pagination-bullet';
        const truncated = total > 5;
        const prevHidden = lastHidden;
        const isHidden = visiblePagerItems.indexOf(index + 1) === -1;
        lastHidden = isHidden;
        if (current === index + 1) {
          className += ' swiper-pagination-bullet-active';
        }
        if (truncated && isHidden) {
          className += ' swiper-pagination-bullet-hidden';
        }

        /* eslint-disable indent */
        return truncated && isHidden && !prevHidden
          ? '<span class="swiper-pagination-ellipsis">...</span>'
          : `<span class="${className}" tabindex="0">${index + 1}</span>`;
        /* eslint-enable indent */
      })
      .join('\n');
  },
});

const handleFewerSlides = (windowWidth, data, numOfSlides, container) => {
  // Center slides when larger screens have less than expected
  if (
    (windowWidth >= 768 && numOfSlides < data.slidesPerViewMd) ||
    (windowWidth >= 1200 && numOfSlides < data.slidesPerViewXl)
  ) {
    container
      .querySelector('.swiper-wrapper')
      .classList.add('justify-content-center');
  } else {
    container
      .querySelector('.swiper-wrapper')
      .classList.remove('justify-content-center');
  }
};

const handleLooping = (windowWidth, data, numOfSlides, container) => {
  // Turn off looping and pagination when
  // slide count is less than or equal to slides per view
  // Also toggles a decorator class on the container to adjust pagination padding
  /* eslint-disable*/
  const outerContainer = container.closest('.swiper-outer-container');

  if (
    (windowWidth < 768 && numOfSlides <= parseFloat(data.slidesPerView)) ||
    (windowWidth >= 768 && numOfSlides <= parseInt(data.slidesPerViewMd)) ||
    (windowWidth >= 1200 && numOfSlides <= parseInt(data.slidesPerViewXl))
  ) {
    outerContainer.classList.add('no-pagination');
    container.classList.add('no-pagination');
    return false;
  }

  outerContainer.classList.remove('no-pagination');
  container.classList.remove('no-pagination');
  return true;
  /* eslint-enable */
};

export function initializeCarousel(container) {
  const windowWidth = window.innerWidth;
  const data = container.dataset;
  const numOfSlides = container.querySelectorAll(
    '.swiper-slide:not(.swiper-slide-duplicate)'
  ).length;
  const outerContainer = container.closest('.swiper-outer-container');
  const nextBtn = outerContainer.querySelector('.swiper-button-next');
  const prevBtn = outerContainer.querySelector('.swiper-button-prev');

  handleFewerSlides(windowWidth, data, numOfSlides, container);
  let options = {
    modules: [Navigation, Pagination],
    direction: 'horizontal',
    loopPreventsSliding: false,
    loopAddBlankSlides: windowWidth > 768,
    loop: handleLooping(windowWidth, data, numOfSlides, container),
    watchOverflow: true, // Only works when loop is false
    observer: true,
    observeParents: true,
    keyboard: {
      enabled: true,
    },
    navigation: {
      nextEl: nextBtn,
      prevEl: prevBtn,
    },
    /* eslint-disable*/
    pagination: getCustomPagination(container),
    breakpoints: {
      0: {
        centeredSlides: true,
        slidesPerView: parseFloat(data.slidesPerView),
        spaceBetween: parseInt(data.spaceBetween),
      },
      768: {
        centeredSlides: false,
        slidesPerGroup: parseInt(data.slidesPerGroupMd),
        slidesPerView: parseInt(data.slidesPerViewMd),
        spaceBetween: parseInt(data.spaceBetweenMd),
      },
      1200: {
        centeredSlides: false,
        slidesPerGroup: parseInt(data.slidesPerGroupXl),
        slidesPerView: parseInt(data.slidesPerViewXl),
        spaceBetween: parseInt(data.spaceBetweenXl),
      },
    },
    on: {
      unlock: () => {
        nextBtn.classList.remove('swiper-button-lock');
        prevBtn.classList.remove('swiper-button-lock');
      },
    },
  };
  const swiper = new Swiper(container, options);
  /* eslint-enable */
}
// Adds the proper swyper classes to visible slides (where display !== none)
export function decorateSlides(carousel) {
  carousel.querySelectorAll('.non-swiper-slide').forEach((slide) => {
    slide.classList.remove('non-swiper-slide');
    slide.classList.remove('d-none');
    slide.classList.add('swiper-slide');
  });

  carousel.querySelectorAll('.swiper-slide').forEach((slide) => {
    if (slide.style.display !== 'none') return;
    slide.classList.remove('swiper-slide');
    slide.classList.add('non-swiper-slide');
    slide.classList.add('d-none');
  });
}

export function rebuildCarousel(carousel) {
  carousel.swiper.destroy(true, true);
  initializeCarousel(carousel);
}

export function initializeSwiperCarousel(callback) {
  let tabGroup = document.querySelector('.tab-group.dropdown-switcher');
  if (tabGroup) {
    tabGroup.addEventListener('change', (ev) => {
      let panes = ev.currentTarget.querySelectorAll('.tab-pane');
      panes.forEach((el) => {
        if (el.id === ev.target.value.replace(' ', '-')) {
          el.classList.add('active');
          el.classList.add('show');
        } else {
          el.classList.remove('active');
          el.classList.remove('show');
        }
      });
    });

    let panes = tabGroup.querySelectorAll('.nav-link.carousel-nav');
    panes.forEach((el) => {
      el.addEventListener('shown.bs.tab', (ev) => {
        let tabId = el.dataset.bsTarget;
        let curPane = document.querySelector(tabId + '.tab-pane');
        rebuildCarousel(curPane.querySelector('.swiper-container'));
      });
    });
  }
  const containers = Array.from(document.querySelectorAll('.swiper-container'));
  containers.forEach(initializeCarousel);
}
